import { render, staticRenderFns } from "./jingtan.vue?vue&type=template&id=3d2f7317&scoped=true&"
import script from "./jingtan.vue?vue&type=script&lang=js&"
export * from "./jingtan.vue?vue&type=script&lang=js&"
import style0 from "./jingtan.vue?vue&type=style&index=0&id=3d2f7317&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2f7317",
  null
  
)

export default component.exports